export default ['manypets', 'exoticdirect', 'manygroup', 'vetbox']
